import { Controller } from 'stimulus';

// Expand-on-focus inline editing for a task-template parameter (Claude Design
// "Task Parameters Editor", Frame 1 phase 2). The collapsed summary and the full
// editor live side by side inside one param-grid cell; this just swaps which is
// visible and makes the expanded cell span the grid's full width. Saving submits
// the form, which re-renders the whole panel, so collapse-after-save is automatic
// (the fresh render starts collapsed). Cancel collapses without saving.
export default class extends Controller {
  static targets = ['collapsed', 'editor'];

  expand(event) {
    // Grabbing the drag handle should sort, not expand.
    if (event && event.target && event.target.closest && event.target.closest('[name=sort_handle]')) return;

    this.collapsedTarget.classList.add('hidden');
    this.editorTarget.classList.remove('hidden');

    const focusEl = this.editorTarget.querySelector('input:not([type=hidden]), select, textarea');
    if (focusEl) focusEl.focus();
  }

  collapse(event) {
    if (event && event.preventDefault) event.preventDefault();

    this.editorTarget.classList.add('hidden');
    this.collapsedTarget.classList.remove('hidden');
  }
}
